import { ColumnDefinition, RowDefinition, Table } from '@indigo-ag/component-module';
import { DecisionSheetDebt } from '@indigo-ag/schema';
import i18next from 'i18next';
import React from 'react';
import { currency, date } from 'shared';

const EMPTY_VALUE = '-';

enum ColumnId {
  CITY = 'CITY',
  DATE = 'DATE',
  INFORMANT = 'INFORMANT',
  SITUATION = 'SITUATION',
  STATE = 'STATE',
  VALUE = 'VALUE'
}

interface RowShape {
  city: string | undefined;
  occurencyDate: Date | undefined;
  id: string;
  informer: string | undefined;
  situation: string | undefined;
  state: string | undefined;
  value: number | undefined;
}

const columnDefinition: ColumnDefinition<RowShape, ColumnId>[] = [
  {
    id: ColumnId.DATE,
    header: i18next.t('consultationsCard_debtsTable_date'),
    cell: ({ row: { occurencyDate }, SimpleCell }) => (
      <SimpleCell label={occurencyDate ? date.formatDate(occurencyDate) : EMPTY_VALUE} />
    )
  },
  {
    id: ColumnId.VALUE,
    header: i18next.t('consultationsCard_debtsTable_value'),
    cell: ({ row: { value }, SimpleCell }) => (
      <SimpleCell label={value != null ? currency.formatBrazilCurrency(value) : EMPTY_VALUE} />
    )
  },
  {
    id: ColumnId.INFORMANT,
    header: i18next.t('consultationsCard_debtsTable_informer'),
    cell: ({ row: { informer }, SimpleCell }) => <SimpleCell label={informer ?? EMPTY_VALUE} />
  },
  {
    id: ColumnId.SITUATION,
    header: i18next.t('consultationsCard_debtsTable_situation'),
    cell: ({ row: { situation }, SimpleCell }) => <SimpleCell label={situation ?? EMPTY_VALUE} />
  },
  {
    id: ColumnId.CITY,
    header: i18next.t('consultationsCard_debtsTable_city'),
    cell: ({ row: { city }, SimpleCell }) => <SimpleCell label={city ?? EMPTY_VALUE} />
  },
  {
    id: ColumnId.STATE,
    header: i18next.t('consultationsCard_debtsTable_state'),
    cell: ({ row: { state }, SimpleCell }) => <SimpleCell label={state ?? EMPTY_VALUE} />
  }
];

const rowDefinition: RowDefinition<RowShape, ColumnId> = {
  rowId: ({ row: { id } }) => id
};

interface Props {
  debts: DecisionSheetDebt[] | null | undefined;
}

export const DebtsTable = ({ debts }: Props) => {
  if (!debts?.length) {
    return null;
  }

  const data: RowShape[] = debts.map(({ date: occurencyDate, value, informer, situation, city, state }, index) => ({
    id: index.toString(),
    occurencyDate,
    value,
    informer,
    situation,
    city,
    state
  }));

  return <Table columnDefinition={columnDefinition} rowDefinition={rowDefinition} label={''} data={data} />;
};
